type BookingProgressProps = {
  currentStep: number
  onStepChange: (step: number) => void
  skipStops?: boolean
}

const bookingSteps = [
  {
    number: 1,
    label: 'Select Your Ride',
    shortLabel: 'Ride',
  },
  {
    number: 2,
    label: 'Add Stops',
    shortLabel: 'Stops',
  },
  {
    number: 3,
    label: 'Traveler Details',
    shortLabel: 'Details',
  },
  {
    number: 4,
    label: 'Payment',
    shortLabel: 'Payment',
  },
]

export default function BookingProgress({
  currentStep,
  onStepChange,
  skipStops = false,
}: BookingProgressProps) {
  const stepsToRender = bookingSteps.filter(
    (step) => !(skipStops && step.number === 2),
  )

  const currentIndex = stepsToRender.findIndex((s) => s.number === currentStep)
  const safeCurrentIndex = currentIndex >= 0 ? currentIndex : 0

  const stepCount = stepsToRender.length
  const edgeMargin = (1 / (2 * stepCount)) * 100

  return (
    <div className="relative mx-auto w-full max-w-[720px] px-1 sm:px-0">
      {/* Full progress line */}
      <div 
        className="absolute top-[17px] h-[2px] bg-white" 
        style={{ left: `${edgeMargin}%`, right: `${edgeMargin}%` }}
      />

      {/* Completed progress line */}
      <div
        className="absolute top-[17px] h-[2px] bg-brand-orange transition-all duration-300"
        style={{
          left: `${edgeMargin}%`,
          width: `${(safeCurrentIndex / stepCount) * 100}%`,
        }}
      />

      <div
        className="relative z-10 grid gap-1 sm:gap-0"
        style={{ gridTemplateColumns: `repeat(${stepsToRender.length}, minmax(0, 1fr))` }}
      >
        {stepsToRender.map((step, index) => {
          const isActive = step.number === currentStep
          const isCompleted = step.number < currentStep

          const isClickable = step.number < currentStep
          const displayNumber = index + 1

          return (
            <button
              key={step.number}
              type="button"
              disabled={!isClickable}
              onClick={() => {
                if (isClickable) {
                  onStepChange(step.number)
                }
              }}
              className={`flex flex-col items-center px-0.5 text-center sm:px-0 ${
                isClickable
                  ? 'cursor-pointer'
                  : 'cursor-not-allowed opacity-70'
              }`}
            >
              <span
                className={`flex h-[34px] w-[34px] items-center justify-center rounded-full font-poppins text-[13px] font-medium transition-all duration-300 ${
                  isActive
                    ? 'bg-brand-orange text-white'
                    : isCompleted
                      ? 'bg-brand-orange text-white'
                      : 'bg-white text-[#333333]'
                }`}
              >
                {displayNumber}
              </span>

              <span
                className={`mt-2 font-poppins text-[9px] font-medium leading-tight sm:mt-3 sm:text-[12px] ${
                  isActive ? 'text-black' : 'text-[#333333]'
                }`}
              >
                <span className="sm:hidden">{step.shortLabel}</span>
                <span className="hidden sm:inline">{step.label}</span>
              </span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
